import { money } from "@/lib/format";
// Shared payment-status summary for appointment cards (POS + Center Manager).
// Bookings persist payment_status plus (when applicable) amount_paid / balance_due.
export function paymentSummary(a) {
  const price = Number(a.price || 0);
  const paid = Number(a.amount_paid || 0);
  const credit = Number(a.credit_applied || 0);
  const ps = a.payment_status || "unpaid";
  const rawBal = a.balance_due != null ? Number(a.balance_due) : Math.max(0, price - paid - credit);

  // Package redemption: pre-paid when the package was purchased — NEVER show as free/$0.
  const isRedemption = !!a.package_credit_id || ps === "package";
  if (isRedemption) {
    const sv = Number(a.package_session_value || 0);
    const svLabel = sv > 0 ? `${money(sv)}` : "pre-paid";
    const owed = rawBal > 0 ? rawBal : 0; // any upcharge above the session value
    if (owed > 0) {
      return { label: `Package Redemption · ${svLabel} (+ ${money(owed)} due)`, tone: "pending", owed, redemption: true, sessionValue: sv };
    }
    return { label: `Package Redemption · ${svLabel}`, tone: "package", owed: 0, redemption: true, sessionValue: sv };
  }

  if (ps === "refunded") return { label: "Refunded", tone: "due", owed: 0 };
  if (ps === "partially_refunded") return { label: "Partially Refunded", tone: "pending", owed: 0 };
  if (ps === "paid") return { label: "Paid in Full", tone: "paid", owed: 0 };
  if (ps === "free" || (price <= 0 && rawBal <= 0)) return { label: "Free", tone: "free", owed: 0 };

  const owed = rawBal > 0 ? rawBal : Math.max(0, price - paid - credit);
  const label = `Balance Due · ${money(owed)}`;
  // pay-in-person reservations are amber (expected at the door); true unpaid/overdue are red.
  const tone = ps === "pending_payment" ? "pending" : "due";
  return { label, tone, owed };
}

export const PAYMENT_TONE = {
  paid: "bg-[#5C8A72]/15 text-[#3f6b53]",
  free: "bg-[#8FA89B]/15 text-[#4A5D6B]",
  package: "bg-[#144F75]/12 text-[#144F75]",
  pending: "bg-[#E0A458]/18 text-[#9a6b1f]",
  due: "bg-[#B45151]/12 text-[#B45151]",
};
